<app-dialog-base class="modalcreateuser" [Title]='"Users"|translate' [dialogId]="dialogId" [width]="'800px'"
  [height]="'500px'" (onClose)="close()" (onSubmit)="submit()">
  <div class="btn_tabs">
    <button (click)="openTab('userData')" [class.active]="openedTabName == 'userData'">{{"Account"|translate}}</button>
    <button (click)="openTab('userSettings')" [class.active]="openedTabName == 'userSettings'">{{"Access rights and roles"|translate}}</button>
    <button (click)="openTab('interfaceSettings')"
      [class.active]="openedTabName == 'interfaceSettings'">{{"Interface"|translate}}</button>
    <button  *ngIf="model.CompanyId" (click)="openTab('userObjects')"
      [class.active]="openedTabName == 'userObjects'">{{"Objects"|translate}}</button>
    <button *ngIf="false" (click)="openTab('userZones')"
      [class.active]="openedTabName == 'userZones'">{{"Geozones"|translate}}</button>
  </div>
  <div class="horseparator"></div>
  <div id="userData" *ngIf="isSelected('userData')" class="tablewrap">
    <div class="table">
      <div class="datablock">
        <div class="inputgroup">
          <label>{{'Company'|translate}}</label>
          <select class="company-select" title="{{'Company'|translate}}" [(ngModel)]="model.CompanyId">
            <option *ngFor="let company of companies" value="{{company.Id}}"
                    [selected]="model.CompanyId === company.Id">
              {{company.Name}}
            </option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{"Account"|translate}}</label>
          <input placeholder="{{'Account'|translate}}" type="text" [(ngModel)]="model.Name" />
        </div>
<!--        <div class="inputgroup" *ngIf="model.Id > 0">
          <label></label>
          <div class="userstat">
            <div>
              {{"Objects"|translate}}:
              <span>{{model.ObjectsCount}}</span>
            </div>
            <div>
              {{"Geozones"|translate}}:
              <span>{{model.GeozonesCount}}</span>
            </div>
          </div>
        </div>-->
        <div class="inputgroup">
          <label>{{'Phone №'|translate}}</label>
          <input placeholder="{{'Phone №'|translate}}" type="text" [(ngModel)]="model.PhoneNumber" />
        </div>
        <div class="inputgroup">
          <label>{{'Email'|translate}}</label>
          <input placeholder="{{'Email'|translate}}" type="text" [(ngModel)]="model.Email"
            [readonly]="!usersService.IsPermitted(AccessRights.EDITUSERS)" />
        </div>
      </div>
      <div class="blockheader">{{'Geolocation and language'|translate}}</div>
      <div class="datablock">
        <div class="inputgroup">
          <label>{{'Timezone'|translate}}</label>
          <select title="{{'Timezone'|translate}}" [(ngModel)]="model.TimeZone">
            <option *ngFor="let timezone of timezones" value="{{timezone.Name}}"
              [selected]="model.TimeZone === timezone.Name">
              {{timezone.DisplayName}}
            </option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{'Language'|translate}}</label>
          <select title="{{'Language'|translate}}" [(ngModel)]="model.Language">
            <option *ngFor="let language of languages" value="{{language.code}}"
              [selected]="model.Language.toLowerCase() == language.code">
              {{language.discription}}
            </option>
          </select>
        </div>
        <div class="inputgroup">
          <label>{{'Geocoding service'|translate}}</label>
          <select title="{{'Geocoding service'|translate}}" [(ngModel)]="model.Geocoder">
            <option *ngFor="let geocoder of geocoders" value="{{geocoder.Name}}"
              [selected]="model.Geocoder == geocoder.Name">
              {{geocoder.Name|translate}}
            </option>
          </select>
        </div>
        <div class="inputgroup" *ngIf="model.CreatedAt">
          <label>{{'Created at'|translate}}</label>
          <label>{{model.CreatedAt | date: 'dd.MM.yyyy'}}</label>
        </div>
        <div class="inputgroup">
          <label>{{'System of units'|translate}}</label>
          <select title="{{'System of units'|translate}}" (change)="onChangeUnits($event)">
            <option value="" [selected]="!model.HasFlag('MILES')">{{'Metric'|translate}}</option>
            <option value="MILES" [selected]="model.HasFlag('MILES')">{{'Imperial (foots/miles)'|translate}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
  <div id="userSettings" *ngIf="isSelected('userSettings')" class="tablewrap">
    <div class="table">
      <div class="datablock" style="height:175px;">
        <div class="inputgroup">
          <label>{{'Blocked'|translate}}</label>
          <input type="checkbox" [(ngModel)]="model.IsDisabled" />
        </div>
        <div class="inputgroup">
          <label>{{'Role'|translate}}</label>
          <select title="{{'Role'|translate}}" (change)="onChangeMask($event)">
            <option *ngFor="let role of roles" value="{{role.Value}}" [selected]="isRoleSelected(role)">
              {{role.Name | translate}}
            </option>
          </select>
        </div>
          <div class="inputgroup" *ngIf="isCheckboxAvailable()">
          <label>{{'Objects edit'|translate}}</label>
          <input type="checkbox" [checked]="isChecked(AccessRights.EDIT_TRACKERS)" (change)="onToggleMask(AccessRights.EDIT_TRACKERS,$event)" />
        </div>
        <div class="inputgroup" *ngIf="isCheckboxAvailable() && isChecked(AccessRights.EDIT_TRACKERS)">
          <label>{{'Add/remove trackers'|translate}}</label>
          <input type="checkbox" [checked]="isChecked(AccessRights.EDIT_TRACKERS_IMEI)" (change)="onToggleMask(AccessRights.EDIT_TRACKERS_IMEI,$event)" />
        </div>
        <div class="inputgroup" *ngIf="isCheckboxAvailable()">
          <label>{{'View trackers data'|translate}}</label>
          <input type="checkbox" [checked]="isChecked(AccessRights.VIEW_TRACKER_PACKET)" (change)="onToggleMask(AccessRights.VIEW_TRACKER_PACKET ,$event)" />
        </div>
      </div>
      <ng-container *ngIf="model.Id > 0">
        <div class="blockheader">{{'Change password'|translate}}</div>
        <div class="datablock">
          <div class="inputgroup">
            <label>{{'New password'|translate}}</label>
            <input placeholder="{{'New password'|translate}}" type="password" [(ngModel)]="model.Password" />
          </div>
          <div class="inputgroup">
            <label>{{'Password confirmation'|translate}}</label>
            <input placeholder="{{'Password confirmation'|translate}}" type="password"
              [(ngModel)]="model.PasswordConfirmation" />
          </div>
          <div class="inputgroup">
            <label class="addinfo">&nbsp;</label>
            <button class="btn_blue" (click)="changePassword()">{{'Change password'|translate }}</button>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="model.Id == 0 || model.Id == undefined">
        <div class="blockheader">{{'Password'|translate}}</div>
        <div class="datablock">
          <div class="inputgroup">
            <label>{{'New password'|translate}}</label>
            <input placeholder="{{'New password'|translate}}" type="password" [(ngModel)]="model.Password" />
          </div>
          <div class="inputgroup">
            <label>{{'Password confirmation'|translate}}</label>
            <input placeholder="{{'Password confirmation'|translate}}" type="password"
              [(ngModel)]="model.PasswordConfirmation" />
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div id="interfaceSettings" *ngIf="isSelected('interfaceSettings')" class="tablewrap">
    <div class="table">
      <div class="datablock">
        <div class="inputgroup">
          <label>{{'Start page'|translate}}</label>
          <select title="{{'Start page'|translate}}" (change)="onChangeStartPage($event)">
            <option value="" [selected]="!model.HasFlag('START_')"
                    *ngIf="InterfaceIsPermitted(InterfacePermissions.TRACKING)">
              {{'Tracking' | translate}}
            </option>

            <option value="START_ANALYTICS" [selected]="model.HasFlag('START_ANALYTICS')"
                    *ngIf="InterfaceIsPermitted(InterfacePermissions.ANALYTICS)">
              {{'Analytics' | translate}}
            </option>

            <option value="START_REPORTS" [selected]="model.HasFlag('START_REPORTS')"
                    *ngIf="InterfaceIsPermitted(InterfacePermissions.REPORTS)">
              {{'Reports' | translate}}
            </option>

            <option value="START_DRIVERS" [selected]="model.HasFlag('START_DRIVERS')"
                    *ngIf="InterfaceIsPermitted(InterfacePermissions.DRIVERS)">
              {{'Drivers' | translate}}
            </option>

            <option value="START_SERVICE" [selected]="model.HasFlag('START_SERVICE')"
                    *ngIf="InterfaceIsPermitted(InterfacePermissions.SERVICE)">
              {{'Service' | translate}}
            </option>

            <option value="START_DISPATCHER" [selected]="model.HasFlag('START_DISPATCHER')"
                    *ngIf="InterfaceIsPermitted(InterfacePermissions.DISPATCHER)">
              {{'Dispatcher' | translate}}
            </option>

            <option value="START_DATAINFO" [selected]="model.HasFlag('START_DATAINFO')"
                    *ngIf="InterfaceIsPermitted(InterfacePermissions.DATAINFO)">
              {{'Raw data' | translate}}
            </option>
          </select>
        </div>

        <div class="blockheader">{{'Available pages'|translate}}</div>
        <div class="table">
          <table>
            <tr *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.ANALYTICS) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Analytics'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.ANALYTICS)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.ANALYTICS, $event)" />
              </td>
            </tr>
            <tr *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.HISTORY) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'History'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.HISTORY)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.HISTORY, $event)" />
              </td>
            </tr>
            <tr *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.REPORTS) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Reports'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.REPORTS)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.REPORTS, $event)" />
              </td>
            </tr>
            <tr *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DRIVERS) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Drivers'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.DRIVERS)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.DRIVERS, $event)" />
              </td>
            </tr>
            <tr *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.SERVICE) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Service'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.SERVICE)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.SERVICE, $event)" />
              </td>
            </tr>
            <tr *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DISPATCHER) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Dispatcher'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.DISPATCHER)"
                  (change)="onToggleInterfacePermissions(InterfacePermissions.DISPATCHER, $event)" />
              </td>
            </tr>
            <tr *ngIf="usersService.InterfaceIsPermitted(InterfacePermissions.DATAINFO) || usersService.IsPermitted(AccessRights.EDITUSERS)">
              <td>{{'Raw data'|translate}}</td>
              <td>
                <input type="checkbox" [checked]="InterfaceIsPermitted(InterfacePermissions.DATAINFO)"
                       (change)="onToggleMask(AccessRights.VIEW_TRACKER_PACKET, $event)" />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div id="userObjects" *ngIf="isSelected('userObjects')" class="tablewrap">
    <app-objects-list-orchestrator [currentUser]="model"
      [targetUser]="usersService.getCurrentUser()"></app-objects-list-orchestrator>
  </div>
  <!-- <div id="userZones" *ngIf="isSelected('userZones')" class="tablewrap">
    <app-geozones-list-orchestrator [currentUser]="model"
      [targetUser]="usersService.getCurrentUser()"></app-geozones-list-orchestrator>
  </div> -->
</app-dialog-base>
